// This enum represents the team sub nav links on the team page
export enum TeamPageLink {
    ABOUT = "ABOUT",
    ACTIVE_BETTER = "ACTIVE_BETTER",
    MEMBERS = "MEMBERS",
    SUBSCRIPTIONS = "SUBSCRIPTIONS",
    EMAIL = "EMAIL",
}

export type SelectedCaptain = {
    id: string;
    name: string;
};
